/* Znacznik nadgabarytu (2026-10-04). Gdy w koszyku jest front dłuższy niż 120 cm, koszyk zawiera
   dokładnie jedną pozycję „Pakowanie nadgabarytowe" (wariant MARKER: 0 zł, 1000 kg). Stawki wysyłki
   rozpoznają ją po wadze: paczka do 15 kg, paleta euro 15-999 kg, paleta nadgabarytowa od 1000 kg,
   więc klient widzi w kasie jedną, właściwą opcję. Bez frontu > 120 cm znacznik znika.
   Synchronizacja: po każdym shopify:cart:lines-update (konfigurator, szuflada, strona koszyka),
   przy starcie strony z niepustym koszykiem i przed przejściem do kasy. Zmiany koszyka idą jako
   zdarzenie z akcją "update" (ten sam kontrakt co component-cart-items.js), więc szuflada się
   przerysowuje, ale sama nie otwiera. Wymiary z properties _wys_mm / _szer_mm konfiguratora. */
(function () {
  "use strict";
  if (window.ogonyNadgabaryt) return;

  const MARKER = 57410664628564;
  const LIMIT_MM = 1200;
  const SRC = "ogony-nadgabaryt";
  const ROOT = window.Shopify?.routes?.root || "/";
  let running = null;
  let again = false;

  const isMarker = (it) => Number(it.variant_id ?? it.id) === MARKER;
  function isLongFront(it) {
    if (isMarker(it)) return false;
    const p = it.properties || {};
    return Math.max(parseFloat(p._wys_mm) || 0, parseFloat(p._szer_mm) || 0) > LIMIT_MM;
  }

  async function getCart() {
    const r = await fetch(`${ROOT}cart.js`, { headers: { Accept: "application/json" }, cache: "no-store" });
    if (!r.ok) throw new Error(`cart.js ${r.status}`);
    return r.json();
  }
  function sectionIds() {
    const ids = new Set();
    document.querySelectorAll("cart-items-component").forEach((el) => { if (el.dataset.sectionId) ids.add(el.dataset.sectionId); });
    return [...ids];
  }
  async function post(path, body) {
    const ids = sectionIds();
    if (ids.length) { body.sections = ids.join(","); body.sections_url = window.location.pathname; }
    const r = await fetch(`${ROOT}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
    const data = await r.json().catch(() => null);
    if (!r.ok || !data || data.status) throw new Error((data && (data.description || data.message)) || `${path} ${r.status}`);
    return data;
  }
  // Przerysowanie koszyka przez magistralę motywu (szuflada, strona koszyka, licznik).
  async function emit(data, quantity) {
    let Ctor = null;
    try { Ctor = (await import("@shopify/events")).CartLinesUpdateEvent; } catch (_) { /* brak magistrali */ }
    if (!Ctor || typeof Ctor.createPromise !== "function") {
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      return;
    }
    const deferred = Ctor.createPromise();
    document.body.dispatchEvent(new Ctor({
      action: "update", context: "cart",
      lines: [{ merchandiseId: String(MARKER), quantity }], promise: deferred.promise,
    }));
    let cart = null;
    try { cart = await getCart(); } catch (_) { /* przerysowanie i tak z sekcji */ }
    let summary = null;
    try { summary = cart && typeof Ctor.createCartFromAjaxResponse === "function" ? Ctor.createCartFromAjaxResponse(cart) : null; } catch (_) { /* bez podsumowania */ }
    deferred.resolve({
      cart: summary,
      detail: { sections: data.sections || undefined, items: cart ? cart.items : [], itemCount: cart ? cart.item_count : undefined, source: SRC, didError: false },
    });
  }

  async function syncOnce(items) {
    const list = items || (await getCart()).items || [];
    const markers = list.filter(isMarker);
    const need = list.some(isLongFront);
    if (need && markers.length === 0) {
      await emit(await post("cart/add.js", { items: [{ id: MARKER, quantity: 1 }] }), 1);
    } else if (!need && markers.length) {
      for (const m of markers) await emit(await post("cart/change.js", { id: m.key, quantity: 0 }), 0);
    } else if (need && (markers.length > 1 || markers[0].quantity !== 1)) {
      await emit(await post("cart/change.js", { id: markers[0].key, quantity: 1 }), 1);
      for (const m of markers.slice(1)) await emit(await post("cart/change.js", { id: m.key, quantity: 0 }), 0);
    }
  }
  function sync(items) {
    if (running) { again = true; return running; }
    running = (async () => {
      try { await syncOnce(items); } catch (err) { console.warn("[nadgabaryt]", err); }
      while (again) {
        again = false;
        try { await syncOnce(); } catch (err) { console.warn("[nadgabaryt]", err); }
      }
    })().finally(() => { running = null; });
    return running;
  }

  document.addEventListener("shopify:cart:lines-update", (ev) => {
    const p = ev.promise;
    if (!p || typeof p.then !== "function") return;
    p.then((res) => {
      const det = res && res.detail;
      if (!det || det.source === SRC || det.didError) return;
      sync(Array.isArray(det.items) && det.items.length ? det.items : null);
    }).catch(() => { /* zmiana koszyka nieudana: nic do synchronizacji */ });
  }, true);

  // Przed kasą: dokończ synchronizację (maks. 4 s), potem ten sam przycisk jeszcze raz.
  document.addEventListener("click", (ev) => {
    const btn = ev.target instanceof Element ? ev.target.closest('[name="checkout"], a[href$="/checkout"]') : null;
    if (!btn || btn.dataset.ogonyNadgabarytOk) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    Promise.race([sync(), new Promise((rs) => setTimeout(rs, 4000))]).finally(() => {
      btn.dataset.ogonyNadgabarytOk = "1";
      btn.click();
      setTimeout(() => { delete btn.dataset.ogonyNadgabarytOk; }, 4000);
    });
  }, true);

  // Start strony: koszyk z wcześniejszej wizyty.
  function start() {
    const n = parseInt(document.querySelector('[ref="cartBubbleCount"]')?.textContent || "0", 10);
    if (n > 0 || /\/cart\/?$/.test(window.location.pathname)) sync();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  window.ogonyNadgabaryt = { sync, MARKER, LIMIT_MM };
})();
